import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'

const useGetExamList = () => {
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const proGrade = searchParams.get('proGrade')

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const fetch = () => {
		fetchRequest('GET', `/admin/exam/all/list?page=${page}`)
	}

	useEffect(() => {
		fetch()
	}, [page, proGrade])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'type')
					setAlert('시험 종류 입력 양식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading, fetch]
}

export default useGetExamList
